jsonpFunctionUIB([3],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        var saveUrlParams = function(options, callback){
	            var params = [],
	                saveFunc = (options.datapoint == "a")?uDash.saveAttribute:uDash.saveMeta;
	                
	            if (options.params == 'search' || options.params == 'searchAndHash'){
	                if (window.location.search.length>1){
	                    params = params.concat ( decodeURIComponent(window.location.search).substring(1).split('&') );
	                }
	            }
	            if (options.params == 'hash' || options.params == 'searchAndHash'){
	                if (window.location.hash.length>1){
	                    params = params.concat ( decodeURIComponent(window.location.hash).substring(1).split('&') );
	                }
	            }
	            
	            if (params.length > 0){
	                if (options.allowedKeys && options.allowedKeys.length>0) {
	                    var allowedKeys = {};
	                    for (var key in options.allowedKeys){
	                        allowedKeys[options.allowedKeys[key]] = true;
	                    }
	                }
	                
	                if (options.disallowedKeys && options.disallowedKeys.length>0) {
	                    var disallowedKeys = {};
	                    for (var key in options.disallowedKeys){
	                        disallowedKeys[options.disallowedKeys[key]] = true;
	                    }
	                }
	                
	                for (var i = 0; i<params.length; i++){
	                    var keyValue = params[i].split('=');
	                    if (keyValue.length == 2) {
	                        if ((!allowedKeys || allowedKeys[keyValue[0]]) && (!disallowedKeys || !disallowedKeys[keyValue[0]])){
	                            saveFunc(keyValue[0],keyValue[1]);
	                        }
	                    }
	
	                }
	            }
	            callback(null);
	        }
	        return saveUrlParams;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// responses/data-collection/saveUrlParams/saveUrlParams.js